export interface ContentBlock {
  type: string;
  value: string;
  /** Punkter inuti en `box`. Används bara när `type` är `box`. */
  items?: string[];
}

export type LeafStyle = 'standard' | 'compact';

export interface LeafItem {
  id: string;
  /** Kort namn på kortet i rutnätet. */
  name: string;
  /** Rubrik på lövsidan. Saknas fältet används `name`. */
  title?: string;
  image?: string;
  validFrom?: string;
  validTo?: string;
  leafType: 'standard' | 'custom';
  /** Stilmall för lövsidan. Default: `standard`. */
  leafStyle?: LeafStyle;
  content?: ContentBlock[];
  componentId?: string;
}

export interface NavNode {
  id: string;
  name: string;
  image: string;
  validFrom?: string;
  validTo?: string;
  children: TreeNode[];
}

export interface LeafPlacement {
  id: string;
  itemRef: string;
  name?: string;
  cardImage?: string;
  validFrom?: string;
  validTo?: string;
}

export type TreeNode = NavNode | LeafPlacement;

export function isNavNode(node: TreeNode): node is NavNode {
  return 'children' in node && Array.isArray(node.children);
}

export function isLeafPlacement(node: TreeNode): node is LeafPlacement {
  return 'itemRef' in node;
}

export interface TreeCollection {
  id: string;
  name: string;
  /** Kort infotext i skapar-läget om vad samlingen innehåller. */
  description?: string;
  items: Record<string, LeafItem>;
  children: TreeNode[];
}

export interface ResolvedChild {
  id: string;
  kind: 'nav' | 'leaf';
  /** Kort namn på kortet i rutnätet. */
  name: string;
  /** Rubrik på lövsidan. Samma som `name` om leaf saknar `title`. */
  title: string;
  image?: string;
  leafImage?: string;
  leafType?: 'standard' | 'custom';
  leafStyle?: LeafStyle;
  content?: ContentBlock[];
  componentId?: string;
  validFrom?: string;
  validTo?: string;
  children?: ResolvedChild[];
  navNode?: NavNode;
}

export interface LegacyCategory {
  id: string;
  name: string;
  image: string;
  categories?: LegacyCategory[];
  items?: LegacyCategory[];
  content?: ContentBlock[];
}

export interface LegacyDataCollection {
  type: string;
  name: string;
  categories: LegacyCategory[];
}

export interface SelectableNode {
  id: string;
  name: string;
  kind: 'nav' | 'leaf';
  depth: number;
  parentId: string | null;
  childIds: string[];
}

export interface StartStateResult {
  pathNavIds: string[];
  leafPlacementId: string | null;
}
